import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { invitationsApi } from 'src/Services/API';
import { InvitationDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';
import { trackInvitationAccepted } from 'src/Services/Mixpanel/events';

export const useAcceptInvitation = (
  options?: UseMutationOptions<InvitationDto, unknown, string>
) => {
  const queryClient = useQueryClient();

  return useMutation<InvitationDto, unknown, string>(
    'accept-invitation',
    async (token: string) => {
      const response = await invitationsApi.invitationsControllerAccept(token);
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries('fetch-my-pending-invitations');
        queryClient.invalidateQueries('fetch-assets');
      },
      onSuccess: (data: InvitationDto, variables: string, context: unknown) => {
        trackEvent('Invitation', 'accept');
        trackInvitationAccepted();
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
